import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import {useCustomerSelector} from "../../../../store";
import Checkbox from "../../../lib/form/Checkbox/Checkbox";

const SummaryCustomerAccount: React.FC = () => {
  const {t} = useTranslation();
  const {checkout} = useCheckoutContext();
  const {customer} = useCustomerSelector();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState<boolean>(false);

  if ((!checkout.isGuest && !isVisible) || customer.isLoggedIn) {
    return null;
  }

  useEffect(() => {
    setIsVisible(true); // prevents checked checkbox to disappear
    void checkout.put({isGuest: !isChecked});
  }, [isChecked]);

  return (
    <div className="checkout-summary-option">
      <Checkbox
        wrapperClassName="checkbox__wrapper"
        className="checkbox--large"
        checked={isChecked}
        color={"green"}
        onChange={() => setIsChecked(!isChecked)}
      >
        <strong>{t("checkout.createCustomerAccount")}</strong>{" " + t("checkout.benefitFromExclusiveOffers")}
      </Checkbox>
    </div>
  );
};

export default SummaryCustomerAccount;
